"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_once_1 = require("../use-once");
var use_shared_collection_1 = require("./use-shared-collection");
function useResolvedCollectionValue(key, valueKey) {
    var _a = use_shared_collection_1.useSingleCollectionValue(key, valueKey), value = _a[0], setValue = _a[1];
    use_once_1.useOnceAsync(function () { return key.resolver.initialize(); });
    react_1.useLayoutEffect(function () { return requestValue(); }, [valueKey, value]);
    react_1.useEffect(function () {
        key.resolver.resolveRequests();
    });
    function requestValue() {
        if (valueKey && value === undefined) {
            key.resolver.requestValue(valueKey);
        }
    }
    return [value, setValue];
}
exports.useResolvedCollectionValue = useResolvedCollectionValue;
function useCollectionValuesResolution(key, keys, values) {
    if (!key.resolver)
        return;
    use_once_1.useOnceAsync(function () { return key.resolver.initialize(); });
    react_1.useLayoutEffect(function () { return requestValues(); }, [keys, values]);
    react_1.useEffect(function () {
        key.resolver.resolveRequests();
    });
    function requestValues() {
        if (!keys)
            return;
        keys.filter(function (valueKey) { return values[valueKey] === undefined; }).forEach(function (valueKey) {
            return key.resolver.requestValue(valueKey);
        });
    }
}
exports.useCollectionValuesResolution = useCollectionValuesResolution;
var SharedCollectionResolverState;
(function (SharedCollectionResolverState) {
    SharedCollectionResolverState[SharedCollectionResolverState["INITIALIZING"] = 0] = "INITIALIZING";
    SharedCollectionResolverState[SharedCollectionResolverState["INITIALIZED"] = 1] = "INITIALIZED";
    SharedCollectionResolverState[SharedCollectionResolverState["NOT_INITIALIZED"] = 2] = "NOT_INITIALIZED";
})(SharedCollectionResolverState || (SharedCollectionResolverState = {}));
var NOT_INITIALIZED = SharedCollectionResolverState.NOT_INITIALIZED, INITIALIZED = SharedCollectionResolverState.INITIALIZED, INITIALIZING = SharedCollectionResolverState.INITIALIZING;
var SharedCollectionResolver = (function () {
    function SharedCollectionResolver(name, collection, resolver) {
        var _this = this;
        this.resolveSinglesBatch = function (requests, modify) { return __awaiter(_this, void 0, void 0, function () {
            var promises;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = requests.map(function (request) { return __awaiter(_this, void 0, void 0, function () {
                            var value, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4, this.resolver.resolve(request)];
                                    case 1:
                                        value = _a.sent();
                                        modify.setValue(request, value);
                                        return [3, 3];
                                    case 2:
                                        error_1 = _a.sent();
                                        console.error("Error resolving " + this.name + " value for " + request, { error: error_1 });
                                        return [3, 3];
                                    case 3: return [2];
                                }
                            });
                        }); });
                        return [4, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.name = name;
        this.collection = collection;
        this.resolver = resolver;
        this.state = resolver.initialize ? NOT_INITIALIZED : INITIALIZED;
        this.pending = [];
        this.resolving = [];
    }
    SharedCollectionResolver.prototype.requestValue = function (valueKey) {
        if (this.collection.hasKey(valueKey))
            return;
        if (this.pending.indexOf(valueKey) !== -1)
            return;
        this.pending.push(valueKey);
    };
    SharedCollectionResolver.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state !== NOT_INITIALIZED)
                            return [2];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.state = INITIALIZING;
                        return [4, this.resolver.initialize(this.collection)];
                    case 2:
                        _a.sent();
                        return [3, 5];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Error initializing " + this.name, { error: error_2 });
                        return [3, 5];
                    case 4:
                        this.pending = this.pending.filter(function (request) { return !_this.collection.hasKey(request); });
                        this.state = INITIALIZED;
                        this.resolveRequests();
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    SharedCollectionResolver.prototype.resolveRequests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requests, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.pending.length === 0)
                            return [2];
                        if (this.state === INITIALIZING)
                            return [2];
                        requests = this.popPendingRequests();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.resolving = this.resolving.concat(requests);
                        return [4, this.resolveBatch(requests)];
                    case 2:
                        _a.sent();
                        this.resolveUnresolvedRequests(requests);
                        return [3, 5];
                    case 3:
                        error_3 = _a.sent();
                        console.error("Error resolving " + this.name + " batch", { error: error_3 });
                        return [3, 5];
                    case 4:
                        this.removeFromResolving(requests);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    SharedCollectionResolver.prototype.isResolving = function (key) {
        if (this.state === INITIALIZING)
            return true;
        if (this.pending.includes(key))
            return true;
        if (this.resolving.includes(key))
            return true;
        return false;
    };
    SharedCollectionResolver.prototype.valuesChanged = function (update) {
        if (this.resolver.valuesUpdated) {
            this.resolver.valuesUpdated(update);
        }
    };
    SharedCollectionResolver.prototype.valuesRemoved = function (keys) {
        if (this.resolver.valuesRemoved) {
            this.resolver.valuesRemoved(keys);
        }
    };
    SharedCollectionResolver.prototype.resolveBatch = function (requests) {
        if (this.resolver.resolveBatch) {
            return this.resolver.resolveBatch(requests, this.collection);
        }
        else {
            return this.resolveSinglesBatch(requests, this.collection);
        }
    };
    SharedCollectionResolver.prototype.resolveUnresolvedRequests = function (requests) {
        var update = {};
        var shouldUpdate = false;
        for (var _i = 0, requests_1 = requests; _i < requests_1.length; _i++) {
            var request = requests_1[_i];
            if (!this.collection.hasKey(request)) {
                update[request] = null;
                shouldUpdate = true;
            }
        }
        if (shouldUpdate === true)
            this.collection.update(update);
    };
    SharedCollectionResolver.prototype.popPendingRequests = function () {
        var popped = __spreadArrays(this.pending);
        this.pending = [];
        return popped;
    };
    SharedCollectionResolver.prototype.removeFromResolving = function (requests) {
        this.resolving = this.resolving.filter(function (fkey) { return !requests.includes(fkey); });
    };
    return SharedCollectionResolver;
}());
exports.SharedCollectionResolver = SharedCollectionResolver;
//# sourceMappingURL=data:application/json;base64,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